import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { baseAPICall } from 'services/baseAPICall'
import { clientInstance } from 'utils/http-client'

// Types
export interface GlobalCampaignSettings {
  id: number
  unsubscribe_text: string
  sequence_prioritization: 'followups' | 'new_leads'
  include_auto_replies: boolean
  default_unsubscribe_text: string
  created: string
  modified: string
}

export interface UpdateGlobalCampaignSettingsPayload {
  unsubscribe_text?: string
  sequence_prioritization?: 'followups' | 'new_leads'
  include_auto_replies?: boolean
}

// Query keys
export const globalSettingsKeys = {
  all: ['global-campaign-settings'] as const,
}

// API calls
const getGlobalSettings = async (): Promise<GlobalCampaignSettings> => {
  return baseAPICall<GlobalCampaignSettings>(() =>
    clientInstance.get('/emailbison/global-settings/')
  )
}

const updateGlobalSettings = async (
  payload: UpdateGlobalCampaignSettingsPayload
): Promise<GlobalCampaignSettings> => {
  return baseAPICall<GlobalCampaignSettings>(() =>
    clientInstance.patch('/emailbison/global-settings/', payload)
  )
}

// Hooks
export const useGetGlobalCampaignSettings = () => {
  return useQuery({
    queryKey: globalSettingsKeys.all,
    queryFn: getGlobalSettings,
  })
}

export const useUpdateGlobalCampaignSettings = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateGlobalSettings,
    onSuccess: (data) => {
      queryClient.setQueryData(globalSettingsKeys.all, data)
    },
  })
}
